import { handleCellWidth } from './fieldDict'
import { deepClone } from './utils.js'
const defMeter = {
  field: 'checkbox',
  pinned: 'left',
  headerName: '',
  headerComponent: 'headerDefSelect',
  cellRenderer: 'defSelect',
  suppressColumnsToolPanel: true,
  minWidth: 40,
  maxWidth: 40
}

const defSecMeter = {
  headerName: '',
  field: 'checkbox',
  headerClass: 'c-header_parent',
  suppressColumnsToolPanel: true,
  children: [
    {
      field: 'checkbox',
      pinned: 'left',
      headerName: '',
      headerComponent: 'headerDefSelect',
      cellRenderer: 'defSelect',
      minWidth: 40,
      maxWidth: 40,
      suppressColumnsToolPanel: true,
      headerClass: 'c-header_child'
    }
  ]
}
const lastDefMeter = {
  headerName: '',
  field: 'fill',
  flex: 1,
  minWidth: 0,
  suppressColumnsToolPanel: true,
}
const lastSecDefMeter = {
  headerName: '',
  field: 'last',
  headerClass: 'c-header_parent',
  suppressColumnsToolPanel: true,
  children: [
    {
      headerName: '',
      field: 'fill',
      flex: 1,
      minWidth: 0,
      headerClass: 'c-header_child',
      suppressColumnsToolPanel: true,
    }
  ]
}
// 默认表头
const parentMeter = {
  field: 'checkbox',
  pinned: 'left',
  headerName: '',
  headerComponent: 'headerSelect',
  cellRenderer: 'parentSelect',
  suppressColumnsToolPanel: true,
  minWidth: 40,
  maxWidth: 40
}

// 二级表头
const parentSecMeter = {
  headerName: '',
  field: 'checkbox',
  pinned: 'left',
  headerClass: 'c-header_parent',
  suppressColumnsToolPanel: true,
  children: [
    {
      field: 'checkbox',
      headerName: '',
      pinned: 'left',
      headerComponent: 'headerSelect',
      cellRenderer: 'parentSelect',
      suppressColumnsToolPanel: true,
      minWidth: 40,
      maxWidth: 40,
      headerClass: 'c-header_child'
    }
  ]
}

const childMeter = {
  field: 'checkbox',
  pinned: (params) => {
    return params.data._childCount ? null : 'left'
  },
  headerName: '',
  cellRenderer: 'childSelect',
  minWidth: 40,
  maxWidth: 40,
  suppressColumnsToolPanel: true,
  colSpan: (params) => {
    return params.data._childCount ? 99 : 1
  }
}
const childSecMeter = {
  headerName: '',
  headerClass: 'c-header_parent',
  suppressColumnsToolPanel: true,
  children: [
    {
      field: 'checkbox',
      pinned: (params) => {
        return params.data._childCount ? null : 'left'
      },
      suppressColumnsToolPanel: true,
      headerName: '',
      cellRenderer: 'childSelect',
      minWidth: 40,
      maxWidth: 40,
      headerClass: 'c-header_child',
      colSpan: (params) => {
        return params.data._childCount ? 99 : 1
      }
    }
  ]
}
// 父子表 展开列
const spreadMeter = {
  headerName: '',
  field: '_selected',
  pinned: 'left',
  cellRenderer: 'agGroupCellRenderer',
  minWidth: 40,
  maxWidth: 40,
  suppressColumnsToolPanel: true,
  valueGetter: () => {
    return ''
  }
}

const spreadSecMeter = {
  headerName: '',
  field: '_selected',
  headerClass: 'c-header_parent',
  suppressColumnsToolPanel: true,
  children: [
    {
      headerName: '_selected',
      field: '_selected',
      pinned: 'left',
      cellRenderer: 'agGroupCellRenderer',
      minWidth: 40,
      maxWidth: 40,
      suppressColumnsToolPanel: true,
      headerClass: 'c-header_child',
      valueGetter: () => {
        return ''
      }
    }
  ]
}

const childSelectAllMeter = {
  field: 'childSelect',
  pinned: (params) => {
    return params.data._childCount ? null : 'left'
  },
  headerName: '',
  suppressColumnsToolPanel: true,
  headerComponent: 'childHeaderSelect',
  cellRenderer: 'childSelect',
  minWidth: 40,
  maxWidth: 40,
  colSpan: (params) => {
    return params.data._childCount ? 99 : 1
  }
}

// 编辑单元格 标题为蓝色
const handleHeaderDefEdit = (item) => {
  let meter = deepClone(item)
  if (meter.children && meter.children.length) {
    meter = {
      ...meter,
      children: meter.children.map((el) => {
        if (!el.headerClass && el.editable) {
          return {
            ...el,
            headerClass: `c-header_editor`
          }
        }
        return el
      })
    }
  } else {
    if (!meter.headerClass && meter.editable) {
      meter = {
        ...meter,
        headerClass: `c-header_editor`
      }
    }
  }
  return meter
}

const handleItemWidth = (item, firHeaderName) => {
  if (item.width) {
    return item
  }
  const cellWidth = handleCellWidth(item.headerName, firHeaderName)
  let headerWidth = 0
  if (!firHeaderName) {
    headerWidth = (item.headerName.length + 2) * 14 + 22
  }

  if (cellWidth) {
    // const width = +cellWidth > +headerWidth ? cellWidth : headerWidth
    return {
      ...item,
      width: +cellWidth > +headerWidth ? cellWidth : headerWidth
    }
  }
  return item
}
const handleCellRenderer = (columnDefs) => {
  return columnDefs.map((item) => {
    if (!item.cellRendererFramework && !item.hideRender) {
      return {
        tooltipField: item.tooltipValueGetter ? '' : item.field,
        headerTooltip: item.headerName,
        cellRenderer(params) {
          const showValue = params.valueFormatted
            ? params.valueFormatted
            : params.value
          const val = params.context.enableZeroValue
            ? showValue !== null && showValue !== undefined
              ? showValue
              : ''
            : showValue || ''

          return `<div class="ag-text-ellipsis">${val}</div>`
        },
        ...item
      }
    }

    return {
      tooltipField: item.tooltipValueGetter ? '' : item.field,
      headerTooltip: item.headerName,
      ...item
    }
  })
}
const handleGridColumnDefs = (
  isSubtable,
  hasSecMeter,
  tableSelection,
  columnDefs,
  childAllSelect
) => {
  const middleColumnDefs = handleCellRenderer(columnDefs)
  let firstColumnDef
  let spreadColumnDef = null
  if (isSubtable) {
    firstColumnDef = hasSecMeter
      ? parentSecMeter
      : childAllSelect
        ? null
        : parentMeter
    spreadColumnDef = hasSecMeter ? spreadSecMeter : spreadMeter
  } else {
    firstColumnDef = hasSecMeter ? defSecMeter : defMeter
  }
  const totalItem = [
    tableSelection ? firstColumnDef : null,
    spreadColumnDef,
    ...middleColumnDefs,
    hasSecMeter ? lastSecDefMeter : lastDefMeter
  ].filter((item) => item)

  const layoutList = []
  totalItem.forEach((item) => {
    if (
      item.headerName &&
      item.headerName !== '' &&
      item.headerName !== 'checkbox' &&
      item.field
    ) {
      layoutList.push({ field: item.field })
    }
  })

  return totalItem.map((item) => {
    if (!item.columnsMenuParams) {
      item.columnsMenuParams = {}
    }
    item.columnsMenuParams.columnLayout = layoutList
    if (hasSecMeter) {
      if (item.children && item.children.length > 0) {
        return handleHeaderDefEdit({
          ...item,
          children: item.children.map((el) => {
            return handleItemWidth(el, item.headerName)
          })
        })
      }
      return handleHeaderDefEdit(item)
    } else {
      return handleHeaderDefEdit(handleItemWidth(item))
    }
  })
}
const handleGridChildColumnDefs = (
  hasSecMeter,
  tableSelection,
  columnDefs,
  childAllSelect
) => {
  const childColumnDefs = handleCellRenderer(columnDefs)
  if (childColumnDefs[0].field !== 'checkbox') {
    const hasSecMeter = childColumnDefs.some((item) => item.children)
    if (tableSelection) {
      childColumnDefs.unshift(
        childAllSelect
          ? childSelectAllMeter
          : hasSecMeter
            ? childSecMeter
            : childMeter
      )
    }
  }
  if (childColumnDefs[childColumnDefs.length - 1].field !== 'fill') {
    childColumnDefs.push({
      headerName: '',
      field: 'fill',
      minWidth: 0,
      flex: 1,
      suppressColumnsToolPanel: true
    })
  }
  return childColumnDefs.map((item) => {
    if (hasSecMeter) {
      if (item.children && item.children.length > 0) {
        return handleHeaderDefEdit({
          ...item,
          children: item.children.map((el) => {
            return handleItemWidth(el, item.headerName)
          })
        })
      }
      return handleHeaderDefEdit(item)
    } else {
      return handleHeaderDefEdit(handleItemWidth(item))
    }
  })
}
export { handleGridColumnDefs, handleGridChildColumnDefs }
